<template>
  <svg
    class="radial-progress-bar"
    :width="diameter"
    :height="diameter"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      :transform="'rotate(' + rotation + ', ' + radius + ',' + radius + ')'"
      r="296.15384615384613"
      :cx="radius"
      :cy="radius"
      overflow="hidden"
      fill="transparent"
      :stroke="strokeColor"
      stroke-dasharray="1860.7894948185697"
      stroke-dashoffset="0"
      stroke-linecap="round"
      :style="innerStrokeStyle as any"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    animateSpeed: {
      type: Number,
      required: false,
      default: 1500,
    },
    strokeColor: {
      type: String,
      required: true,
      default: "#EEEFF0",
    },
    parentClicked: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      strokeDashoffset: 1860.7894948185697,
      diameter: 400,
      rotation: 180,
      strokeWidth: 16,
      visibility: "hidden",
      transitionValue: `${this.animateSpeed}ms linear` as string | null,
    };
  },

  computed: {
    radius() {
      return 350;
    },
    innerStrokeStyle() {
      return {
        height: `${this.diameter}px`,
        width: `${this.diameter}px`,
        strokeWidth: `${this.strokeWidth}px`,
        strokeDashoffset: this.strokeDashoffset,
        visibility: this.visibility,
        transition: this.transitionValue,
      };
    },
  },

  watch: {
    parentClicked() {
      this.reload();
    },
  },
  created() {
    setTimeout(this.load, 500);
  },
  methods: {
    load() {
      this.transitionValue = `${this.animateSpeed}ms linear`;
      this.strokeDashoffset = 1399.5526463729987;
      this.visibility = "visible";
    },
    unload() {
      this.transitionValue = null;
      this.visibility = "hidden";
      this.strokeDashoffset = 1860.7894948185697;
    },
    reload() {
      this.unload();
      setTimeout(() => {
        this.load();
      }, 500);
    },
  },
});
</script>
